export interface StateOption {
  value: string;
  label: string;
}

export const EMPTY_STATE_OPTION: StateOption = {
  value: "",
  label: "Não informado",
};

export const BRAZIL_STATES: StateOption[] = [
  { value: "AC", label: "AC — Acre" },
  { value: "AL", label: "AL — Alagoas" },
  { value: "AP", label: "AP — Amapá" },
  { value: "AM", label: "AM — Amazonas" },
  { value: "BA", label: "BA — Bahia" },
  { value: "CE", label: "CE — Ceará" },
  { value: "DF", label: "DF — Distrito Federal" },
  { value: "ES", label: "ES — Espírito Santo" },
  { value: "GO", label: "GO — Goiás" },
  { value: "MA", label: "MA — Maranhão" },
  { value: "MT", label: "MT — Mato Grosso" },
  { value: "MS", label: "MS — Mato Grosso do Sul" },
  { value: "MG", label: "MG — Minas Gerais" },
  { value: "PA", label: "PA — Pará" },
  { value: "PB", label: "PB — Paraíba" },
  { value: "PR", label: "PR — Paraná" },
  { value: "PE", label: "PE — Pernambuco" },
  { value: "PI", label: "PI — Piauí" },
  { value: "RJ", label: "RJ — Rio de Janeiro" },
  { value: "RN", label: "RN — Rio Grande do Norte" },
  { value: "RS", label: "RS — Rio Grande do Sul" },
  { value: "RO", label: "RO — Rondônia" },
  { value: "RR", label: "RR — Roraima" },
  { value: "SC", label: "SC — Santa Catarina" },
  { value: "SP", label: "SP — São Paulo" },
  { value: "SE", label: "SE — Sergipe" },
  { value: "TO", label: "TO — Tocantins" },
];

export const toStateOption = (value?: string | null): StateOption => {
  const stored = (value ?? "").trim();
  if (!stored) return EMPTY_STATE_OPTION;

  const known = BRAZIL_STATES.find(
    (state) => state.value === stored.toUpperCase()
  );

  return known ?? { value: stored, label: stored };
};

export const stateOptions = (value?: string | null): StateOption[] => {
  const current = toStateOption(value);
  const isKnown =
    !current.value || BRAZIL_STATES.some((s) => s.value === current.value);

  return isKnown
    ? [EMPTY_STATE_OPTION, ...BRAZIL_STATES]
    : [EMPTY_STATE_OPTION, current, ...BRAZIL_STATES];
};
